"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BureauCard = exports.FlexHeader = exports.MobileBureauColumn = exports.ReportCardsContainer = exports.BureauColumn = exports.Article = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const base_react_components_1 = require("@navinc/base-react-components");
const toggle_1 = __importDefault(require("../../components/toggle"));
const collapsed_bureau_card_1 = __importDefault(require("./components/collapsed-bureau-card"));
const column_navigation_1 = __importDefault(require("./components/column-navigation"));
const download_page_link_1 = __importDefault(require("../../components/download-page-link"));
const not_enough_data_message_1 = __importDefault(require("./components/not-enough-data-message"));
const recent_bankruptcy_message_1 = __importDefault(require("./components/recent-bankruptcy-message"));
const scoring_model_1 = require("../../utils/scoring-model");
exports.Article = styled_components_1.default.div.withConfig({ displayName: "reports-Article", componentId: "reports-e3jrff" }) `
  display: flex;
  flex-direction: column;
  padding: 16px 0;

  & > :first-child {
    margin-bottom: 8px;
  }

  @media (${base_react_components_1.theme.forLargerThanPhone}) {
    padding: 24px 0;
  }
`;
exports.BureauColumn = styled_components_1.default.div.withConfig({ displayName: "reports-BureauColumn", componentId: "reports-fuagz3" }) `
  display: none;
  @media (${base_react_components_1.theme.forLargerThanPhone}) {
    display: block;
    flex: 0 1 350px;
  }
`;
exports.ReportCardsContainer = styled_components_1.default.div.withConfig({ displayName: "reports-ReportCardsContainer", componentId: "reports-u0chok" }) `
  display: grid;
  grid-row-gap: 16px;

  @supports not (display: grid) {
    display: flex;
    flex-direction: column;

    & > * {
      margin-bottom: 16px;
    }
  }
`;
exports.MobileBureauColumn = (0, styled_components_1.default)(exports.ReportCardsContainer).withConfig({ displayName: "reports-MobileBureauColumn", componentId: "reports-1dn5ike" }) `
  @media (${base_react_components_1.theme.forLargerThanPhone}) {
    display: none;
  }
`;
exports.FlexHeader = styled_components_1.default.div.withConfig({ displayName: "reports-FlexHeader", componentId: "reports-1iwxajy" }) `
  display: flex;
  justify-content: space-between;
`;
const BureauCard = ({ bureauAddress, bureauScore, bureauSlug, hasDownload = false, hasIdentifier = false, isReportNotFound = true, isLoading = false, notEnoughDataForScore = false, hasRecentBankruptcy = false, reportDate, isDirect = false, reportItems, type, }) => {
    var _a, _b;
    const { pullId } = (0, react_router_dom_1.useParams)();
    const { header: bureauHeader, copy: bureauCopy } = (_b = (_a = (0, scoring_model_1.getScoringModel)(bureauSlug, type)) === null || _a === void 0 ? void 0 : _a.explanation) !== null && _b !== void 0 ? _b : {
        header: '',
        copy: '',
    };
    const shouldShowDownload = [
        hasDownload,
        hasIdentifier,
        !isReportNotFound,
        !isLoading,
        !notEnoughDataForScore,
        !hasRecentBankruptcy,
    ].every(Boolean);
    const renderDataErrors = (screen = 'mobile') => {
        if (!hasIdentifier) {
            return (react_1.default.createElement(base_react_components_1.CardInsight, { actionHref: `/partner/business-match/${bureauSlug}`, actionLabel: "Find my business", copy: "We didn't find your business. Let's try again.", type: "improve", "data-testid": `card-insight:${screen}-we-did-not-find-business` }));
        }
        if (isLoading) {
            return react_1.default.createElement(base_react_components_1.LoadingDots, { "data-testid": `credit-reports:${screen}-data-loading-card:${bureauSlug}` });
        }
        if (notEnoughDataForScore) {
            return (react_1.default.createElement(not_enough_data_message_1.default, { bureauSlug: bureauSlug, businessAddress: bureauAddress, "data-testid": `credit-reports:${screen}-no-data-card:${bureauSlug}` }));
        }
        if (hasRecentBankruptcy) {
            return (react_1.default.createElement(recent_bankruptcy_message_1.default, { bureauSlug: bureauSlug, businessAddress: bureauAddress, "data-testid": `credit-reports:${screen}-recent-bankruptcy-card:${bureauSlug}` }));
        }
        return null;
    };
    return (react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
        react_1.default.createElement(react_router_dom_1.Route, null,
            react_1.default.createElement(exports.MobileBureauColumn, null,
                react_1.default.createElement(collapsed_bureau_card_1.default, { bureau: bureauSlug, scoreType: type, "data-testid": `credit-reports:mobile-card:${bureauSlug}`, hasMatch: hasIdentifier, reportDate: reportDate, score: bureauScore },
                    renderDataErrors('mobile'),
                    react_1.default.createElement(base_react_components_1.Divider, null),
                    react_1.default.createElement(toggle_1.default, null, ({ isOpen, toggle }) => (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(exports.Article, { "data-testid": `credit-reports:toggle:${bureauSlug}`, onClick: toggle },
                            react_1.default.createElement(exports.FlexHeader, null,
                                react_1.default.createElement(base_react_components_1.Copy, { bold: true, size: "sm" }, bureauHeader),
                                react_1.default.createElement(base_react_components_1.Icon, { name: isOpen ? 'actions/carrot-up' : 'actions/carrot-down' })),
                            isOpen && react_1.default.createElement(base_react_components_1.Copy, { size: "sm" }, bureauCopy))))))),
            react_1.default.createElement(exports.BureauColumn, null,
                react_1.default.createElement(column_navigation_1.default, { bureauSlug: bureauSlug, scoreType: type, hasMatch: hasIdentifier, reportDate: reportDate, reportException: renderDataErrors('desktop'), reportItems: reportItems, score: bureauScore },
                    shouldShowDownload && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { "data-testid": `credit-reports:download-link:${bureauSlug}` },
                            react_1.default.createElement(download_page_link_1.default, { to: isDirect
                                    ? `/client/reports/${pullId}/download`
                                    : `/partner/report/download?reportpath=/partner/reports/print-view/${bureauSlug}` })),
                        react_1.default.createElement(base_react_components_1.Divider, null))),
                    react_1.default.createElement(exports.Article, null,
                        react_1.default.createElement(base_react_components_1.Copy, { bold: true, size: "sm" }, bureauHeader),
                        react_1.default.createElement(base_react_components_1.Copy, { size: "sm" }, bureauCopy)))))));
};
exports.BureauCard = BureauCard;
exports.default = exports.BureauCard;
//# sourceMappingURL=index.js.map